import styled from 'styled-components';
import background from '../../../assets/images/heroMoblie.svg';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: row;
  //overflow-y: hidden;
`;
export const FormContainer = styled.div`
  width: 50%;
  margin: 0 auto;
  padding: 40px 100px;
  background-color: #fff;
  @media screen and (max-width: 820px) {
    padding: 30px;
  }

  h1 {
    margin: 50px 0 50px 0;
    font-size: 28px;
    line-height: 38px;
    color: #2b2f38;
  }
  p {
    margin-top: 20px;
    text-align: center;
    color: #667085;
  }
  a {
    text-decoration: none;
    color: #3730a3;
  }
  form {
    label {
      font-size: 14px;
      line-height: 20px;
      padding: 0 5px;
      color: #383e49;
    }

    input {
      width: 100%;
      height: 43px;
      margin-top: 10px;
      border: solid 1px #e0e2e6;
      border-radius: 10px;
      padding: 12px 14px;
      transition: all 0.3s ease;

      &:focus {
        outline: #4f46e5;
        border: 1px solid #3730a3;
        background: transparent;
      }
    }
    /* img, */
	.eye {
		position: relative;
		left: 95%;
		bottom: 30px;
		cursor: pointer;
	}
    .single-form {
      margin-bottom: 20px;
      input {
        width: 100%;
      }
    }
    .forgot-password {
      display: flex;
      justify-content: space-between;
      a {
        margin-top: -10px;
        text-decoration: none;
        color: #3730a3;
      }
    }
    button {
      margin-top: 40px;
      height: 43px;
      background-color: #3730a3;
      color: #fff;
      width: 100%;
      border: 1px solid #4f46e5;
      border-radius: 10px;
      padding: 12px 20px;
      cursor: pointer;
    }
  }
  @media screen and (max-width: 820px) {
    width: 100%;
    background-color: #fff;
  }
`;
export const ImgSection = styled.div`
  width: 50%;
  background: url(${background}) no-repeat;
  background-size: cover;
  height: 100vh;
  overflow-y: hidden;
  padding: 550px 30px 30px 30px;

  div {
    width: 100%;
    height: 172px;
    padding: 32px;
    border-radius: 8px;
    opacity: 0px;
    background-color: #c4b5fd;
    p {
      margin-top: 15px;
      font-size: 20px;
      line-height: 28px;
      color: #3730a3;
    }
  }

  @media screen and (max-width: 820px) {
    display: none;
  }
`;
